import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import MainBanner from '../../components/MainBanner';
import MultiColumnsInsight from '../../components/MultiColumnsInsight';
import NewColumnWithForm from "../../components/NewColumnWithForm";
import AllBlogs from '../../components/AllBlogs';

export default function PodcastsPage({
    global,
    all_podcasts,
}) {

    return (
        <>
            <SeoHead
                page_name={`Podcasts | The global house of tech and transformation recruitment | Lorien`}
                canonical_link={`podcasts`}
            />
            <MainBanner
                global={global}
                pathPrefix={`podcasts_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Podcasts</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/sub-banner-insights.png`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <AllBlogs
                global={global}
                pathPrefix={`podcasts_page.all_blogs`}
                customClass={`py-5 lightGreybg`}
                post={all_podcasts}
                ParentNews={true}
                cardPagePrefix={`podcasts/`}
                enableFilterBy={false}
            />
            <NewColumnWithForm 
                formId={`308d12ba-6cc4-44a5-91e2-76d1d714bf23`}
                successPageUrl={`/about-us/join-us/submission-success`}
            />
            {/* <MultiColumnsInsight
                global={global}
                pathPrefix={`podcasts_page.multi_columns_insight`}
                customClass={`py-5`}
                left_column_content={
                    <>
                        <h2>Want to Know More?</h2>
                    </>
                }
                left_column_button_title_1={`Get in Touch`}
                left_column_button_link_1={`/contact-us/`}
                left_column_button_title_2={`Search More Blogs`}
                left_column_button_link_2={`/insights/`}
                center_column_content={
                    <>
                        <h2>Subscribe to our newsletter</h2>
                        <p>With insight across the whole of Lorien, we'll keep you ahead of the curve on the talent market.</p>
                    </>
                }
                center_formId={`f2973c34-4388-4cf9-b22e-2a16efc93e2a`}
                right_column_content={
                    <>
                        <h2>Download our Latest Report</h2>
                        <p>Fill out the form below to gain exclusive access to the 2023 Salary Survey results!</p>
                    </>
                }
                right_formId={`720cabf0-3d42-4680-b31e-0d77028bff16`}
                center_column_successPageUrl={`/insights/subscription-success`}
                right_column_successPageUrl={`/pdf/WTCW-2024.pdf`}
            /> */}

        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const podcasts = (await Collection('podcasts'))
        .filter(function (post) {
            return (
                post.country?.en.includes("United Kingdom")
            );
        });

    const all_podcasts = podcasts.orderBy('title').getItems().slice();

    return {
        props: {
            global,
            all_podcasts,
        }
    };
}
